import { render, staticRenderFns } from "./BatchResultsDialog.vue?vue&type=template&id=1320351c&scoped=true&"
import script from "./BatchResultsDialog.vue?vue&type=script&lang=js&"
export * from "./BatchResultsDialog.vue?vue&type=script&lang=js&"
import style0 from "./BatchResultsDialog.vue?vue&type=style&index=0&id=1320351c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1320351c",
  null
  
)

export default component.exports